import BaseEnumType from "../../common/base-enum-type";

const KickoffSkip = Object.freeze({
    Safety: new BaseEnumType("safety", "Safety"),
    FieldGoal: new BaseEnumType("fieldGoal", "Field Goal")
});

export default KickoffSkip;
